import { AgentProfile, AppPresence } from "@closerplatform/spinner-openapi";
import classNames from "classnames";
import React from "react";
import { Avatar } from "@fidget/common/components/avatar/avatar";
import { DotIndicator } from "@fidget/common/components/indicators/dotIndicator/dotIndicator";

import sharedStyles from "../styles.css";
import styles from "./adviserNameSummary.css";

interface Props {
  adviser: Pick<AgentProfile, "avatarToken" | "firstName" | "lastName" | "email" | "presence">;
}
export const AdviserNameSummary = ({ adviser }: Props) => {
  const avatarToken = adviser.avatarToken;

  return (
    <div className={classNames(sharedStyles.container, styles.container)}>
      <div className={styles.avatar}>
        <Avatar agent={{ avatarToken, isBot: false }} />
      </div>
      <div className={styles["name-and-email"]}>
        <div className={classNames(sharedStyles["font-content"], styles.name)}>
          <span>{adviser.firstName + " " + adviser.lastName}</span>
          {adviser.presence === AppPresence.Available && (
            <DotIndicator className={styles["presence-indicator"]} variant="presence" />
          )}
        </div>
        <div className={classNames(sharedStyles["font-description"], styles.email)}>
          {adviser.email}
        </div>
      </div>
    </div>
  );
};
